module.exports = __webpack_public_path__ + "img/img_cmag5.3b8a7f01.png";